import React, { useState, useImperativeHandle, useEffect, forwardRef, useRef } from 'react'
import Api from '../../../../_helpers/Api'
import { plural, trans } from '../../../../_providers/Translation'
import subscriptionHeadImage from "@/assets/img/contractors/icons/subscription-head.svg"

//images
import docIcon from '../../../../assets/img/icons/document.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import loader from '../../../../assets/img/loader.svg'
import Success from '../../../modals/messages/Success'
import Error from '../../../modals/messages/Error'
import Dropdown from '../../../partials/Dropdown'
import { FormControlLabel, Switch } from '@mui/material'
import Skeleton from 'react-loading-skeleton'

function Warranty(props, ref) {

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        loading: false,
        data: null,
        id: null,
        edit: false,
        loadingData: false,
    })

    const [validations, setValidations] = useState(null)

    const successModalRef = useRef(null)
    const errorModalRef = useRef(null)
    const inputModelsRef = useRef(null)

    useImperativeHandle(ref, () => ({
        open: (id) => {
            handleShow(id)
        },
        hide: () => {
            handleHide()
        }
    }))

    useEffect(() => {
        if (popup.edit) {
            loadData()
        }
    }, [popup.edit])

    const loadData = () => {
        if (!popup.id) {
            return
        }

        setPopup(prev => ({
            ...prev,
            loadingData: true,
        }))

        Api.get(`contractors/warranties/find?id=${popup.id}`)
            .then(res => {
                setPopup(prev => ({
                    ...prev,
                    data: res.data,
                }))
            })
            .finally(() => {
                setPopup(prev => ({
                    ...prev,
                    loadingData: false,
                }))
            })
    }

    const handleShow = (id = null) => {
        setPopup(prev => ({
            ...prev,
            id: id,
            edit: id ? new Date() : null,
        }))

        show()
    }

    const handleHide = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            id: null,
            data: null,
            edit: false,
        }))

        setValidations(null)

        hide().then(() => {
            if (typeof props.onClose === 'function') {
                props.onClose()
            }
        })

    }

    const show = async () => {
        return new Promise((resolve, reject) => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
            }))

            setTimeout(() => {
                setPopup(prev => ({
                    ...prev,
                    overlay: true,
                    modal: true
                }))

                return resolve()
            }, 50)
        })
    }

    const hide = async () => {
        return new Promise((resolve, reject) => {
            setPopup(prev => ({
                ...prev,
                modal: false,
                loading: false,
            }))

            setTimeout(() => {
                setPopup(prev => ({
                    ...prev,
                    overlay: false,
                    modal: false,
                }))

                return resolve()
            }, 50)
        })
    }

    const handleSave = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url = 'contractors/warranties/' + (popup.id ? 'edit' : 'add')

        let data = new FormData(e.target)


        if (props.contractorId) {
            data.append('contractor_id', props.contractorId)
        }

        if (popup.id) {
            data.append('id', popup.id)
        }

        Api.post(url, data)
            .then(res => {

                handleHide(e)

                if (typeof props.onSave === 'function') {
                    props.onSave(res.data)
                }

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }

            })
    }

    const handleTypeChange = data => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                type: data
            }
        }))
    }

    const handleApplianceChange = data => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                appliancecategory: data,
                appliancebrand: {},
                appliancemodel: {}
            }
        }))

        if (inputModelsRef.current) {
            inputModelsRef.current.reset()
        }
    }

    const handleBrandChange = data => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                appliancebrand: data,
                appliancemodel: {}
            }
        }))

        if (inputModelsRef.current) {
            inputModelsRef.current.reset()
        }
    }

    const handleModelChange = data => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                appliancemodel: data,
            }
        }))
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }


    const handleContractorChange = data => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                contractor: data
            }
        }))
    }

    const handleSwitchChange = e => {
        const { name, checked } = e.target

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: checked ? 1 : 0,
            }
        }))
    }

    return (
        <>
            <Success
                ref={successModalRef}
                mainMessage={trans('headings.success6')}
            />

            <Error
                ref={errorModalRef}
                mainMessage={trans('headings.error3')}
            />
            <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
                <form className={`${popup.modal ? 'show' : ''} popup-primary popup-subscription-type medium`} onSubmit={handleSave}>
                    {popup.data?.contractor_id ? <input type="hidden" name="contractor_id" value={popup.data?.contractor_id} /> : <></>}
                    <div className='head-new'>
                        <img src={subscriptionHeadImage} alt="icon" />
                        <div className='texts'>
                            <h2>
                                {trans('headings.warranty')}
                            </h2>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                            </p>
                        </div>
                        <span className='close' onClick={handleHide}>

                        </span>
                    </div>

                    {popup.loadingData ?
                        <Skeleton height={45} count={5} />
                        :
                        <>
                            <div className='row'>
                                <div className='col'>
                                    <label>
                                        {trans('labels.name')}
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={popup.data?.name || ''}
                                        onChange={handleInputChange}
                                        className={validations && validations.name ? 'validate' : ''}
                                    />
                                </div>
                                <div className='col'>
                                    <label>
                                        {trans('labels.company')}
                                    </label>
                                    <Dropdown
                                        inputName=""
                                        inputValue={popup.data?.contractor?.name || ''}
                                        inputIdName="contractor_id"
                                        inputIdValue={popup.data?.contractor?.id || ''}
                                        url="contractors/dropdown-list"
                                        params={{
                                            id: popup.data?.contractor?.id || null,
                                            limit: 100
                                        }}
                                        inputClassName={validations && validations.contractor_id ? 'validate' : ''}
                                        onChange={handleContractorChange}
                                        inputDisabled={props.contractorId}
                                    />
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col">
                                    <label>
                                        {trans('labels.category')}
                                    </label>
                                    <Dropdown
                                        inputName=""
                                        inputValue={popup.data?.appliancecategory?.name || ''}
                                        inputIdName="appliance_category_id"
                                        inputIdValue={popup.data?.appliancecategory?.id || ''}
                                        url="partners/categories/all"
                                        params={{
                                            id: popup.data?.appliancecategory?.id || null,
                                        }}
                                        inputClassName={validations && validations.appliance_category_id ? 'validate' : ''}
                                        onChange={handleApplianceChange}
                                    />
                                </div>
                                <div className="col">
                                    <label>
                                        {trans('labels.make')}
                                    </label>
                                    <Dropdown
                                        inputName=""
                                        inputValue={popup.data?.appliancebrand?.name || ''}
                                        inputIdName="appliance_brand_id"
                                        inputIdValue={popup.data?.appliancebrand?.id || ''}
                                        url="partners/brands/all"
                                        params={{
                                            id: popup.data?.appliancebrand?.id || null,
                                        }}
                                        inputClassName={validations && validations.appliance_brand_id ? 'validate' : ''}
                                        onChange={handleBrandChange}
                                    />
                                </div>

                                <div className="col">
                                    <label>
                                        {trans('labels.model')}
                                    </label>

                                    <Dropdown
                                        ref={inputModelsRef}
                                        inputName="appliance_model"
                                        inputIdName="appliance_model_id"
                                        inputValue={popup.data?.appliancemodel && popup.data.appliancemodel.name ? popup.data.appliancemodel.name : ''}
                                        inputIdValue={popup.data?.appliancemodel && popup.data.appliancemodel.id ? Number(popup.data.appliancemodel.id) : ''}
                                        inputClassName={validations?.appliance_model_id ? 'validate' : ''}
                                        url="appliances/models/all"
                                        params={{
                                            category_id: popup.data?.appliancecategory && popup.data.appliancecategory.id ? Number(popup.data.appliancecategory.id) : null,
                                            brand_id: popup.data?.appliancebrand && popup.data.appliancebrand.id ? Number(popup.data.appliancebrand.id) : null,
                                        }}
                                        requiredParams={['category_id', 'brand_id']}
                                        onChange={handleModelChange}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>
                                        {trans('labels.serialNo')}
                                    </label>
                                    <input
                                        value={popup.data && popup.data.serial_no ? popup.data.serial_no : ''}
                                        type="text"
                                        name="serial_no"
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="col">
                                    <label>
                                        {trans('labels.productCode')}
                                    </label>
                                    <input
                                        type="text"
                                        name="product_code"
                                        value={popup.data && popup.data.product_code ? popup.data.product_code : ''}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            {/*  <hr />
                            <div className="row">
                                <div
                                    className='col'
                                >
                                    <div className='period-select'>
                                        <label>
                                            {trans('labels.period')}
                                        </label>
                                        <div className='select-holder'>
                                            <input
                                                type="number"
                                                min="0"
                                                step="1"
                                                name="period_value"
                                                value={popup.data?.period_value || ''}
                                                onChange={handleInputChange}
                                                className={validations && validations.period_value ? 'validate' : ''}
                                                style={{
                                                    maxWidth: "100px"
                                                }}
                                            />
                                            <select
                                                name="period_unit"
                                                className={validations && validations.period_unit ? 'validate' : ''}
                                                value={popup.data && popup.data.period_unit ? popup.data.period_unit : ''}
                                                onChange={handleInputChange}
                                            >
                                                <option value={1}>
                                                    {plural('plural_periods.month', 1)}
                                                </option>
                                                <option value={2}>
                                                    {plural('plural_periods.year', 1)}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col'>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                name="is_active"
                                                checked={popup.data?.is_active ? true : false}
                                                onChange={handleSwitchChange}
                                                value={popup.data?.is_active}
                                            />
                                        }
                                        label="Активна гаранция"
                                    />
                                </div>
                            </div> */}
                        </>
                    }

                    <div className="footer align-right">
                        {popup.loading ?
                            <img src={loader} alt="loading" />
                            :
                            <>
                                <button className="button" onClick={handleHide}>
                                    {trans('buttons.cancel')}
                                </button>
                                <button className="button button-primary" type="submit">
                                    {trans('buttons.save')}
                                </button>
                            </>
                        }
                    </div>
                </form>
            </div>
        </>
    )
}

export default forwardRef(Warranty)